import { render, staticRenderFns } from "./VueSnackbar.vue?vue&type=template&id=1007955b&scoped=true&"
import script from "./VueSnackbar.vue?vue&type=script&lang=js&"
export * from "./VueSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./VueSnackbar.vue?vue&type=style&index=0&id=1007955b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007955b",
  null
  
)

export default component.exports